// import './wdyr'; //why did you render lib, comment it out, it makes app slow

import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './index.css';
import './custom-antd.css';
import './responsive-app.css';
import './test-result-card.css';
import * as Sentry from '@sentry/browser';
import App from './App';
import * as serviceWorker from './serviceWorker';

// setup SENTRY for issue tracking in production
if (process.env.NODE_ENV !== 'development') {
  if (
    process.env.REACT_APP_SENTRY_DSN ||
    'https://9b078e0935254104abf6a09c012d0e7b@sentry.io/1785203'
  ) {

    Sentry.init({
      release: 'rate-search@0.1',
      dsn: `${
        process.env.REACT_APP_SENTRY_DSN ||
        'https://9b078e0935254104abf6a09c012d0e7b@sentry.io/1785203'
      }`,
    });
  } else {
    console.log('no dsn found');
  }
}

// remove consoles statements in production
if (process.env.NODE_ENV !== 'development') {
  // window.console.log = window.console.debug = window.console.info = window.console.error = () =>
  //   false;
}

/**
 * @function
 * @description Hook the app to the root of DOM and render it
 * @param {Function} Component - Container Component i.e. <App /> of the web app
 * @returns {Object}
 *
 * @author by prime freight
 */
// My Github {@link https://github.com/sudhir-pradhan}
const render = (Component) => {
  return ReactDOM.render(<Component />, document.getElementById('root'));
};

// Service worker is intentionally UNREGISTERED. The workbox precache was serving stale
// bundles after deploys (users kept seeing the old UI until a hard refresh). This app is
// always-online (live rates), so it gains nothing from offline caching. unregister() also
// removes the SW from users who already have it installed, on their next visit — so the
// stale-deploy problem self-heals. (To re-enable PWA caching, switch back to register().)
serviceWorker.unregister();

// Offline POC (#75): the dev error-overlay's source-map worker throws
// "process is not defined" and HANGS the page on any runtime error, masking the
// real error. Disable runtime-error reporting in the local-rates dev run so
// errors surface via the app's ErrorBoundary + console instead of freezing.
// Gated on the dev local-rates flag — prod and normal dev builds are untouched.
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_LOCAL_RATES === 'yes') {
  try {
    // eslint-disable-next-line global-require
    require('react-error-overlay').stopReportingRuntimeErrors();
  } catch (e) {
    /* react-error-overlay stopReportingRuntimeErrors unavailable — ignore */
  }
}

// render the app

render(App);

// for hot module replacement

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    render(NextApp);
  });
}
